export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        menuId: entity.menuId,
        name: entity.name || '',
        description: entity.description || '',
        posItemId: entity.posItemId || '',
        posName: entity.posName || undefined,
        price: entity.price || 0,
        options: entity.options || { supportedFor: ['sitting', 'takeaway', 'delivery'] },
        tags: entity.tags || [],
        imageGuid: entity.imageGuid || undefined,
        imageUrl: entity.imageUrl || undefined,
        outOfStockDates: entity.outOfStockDates || null,
        availability: entity.availability || {},
        subcategoriesIds: entity.subcategoriesIds || [],
        isDisabled: entity.isDisabled || false,
    };
};
